import {Stack, Typography} from '@mui/material';
import {AlertInfo, CopySection} from 'presentation/components';
import {CopySectionMaskEnum, ProductEnum} from 'presentation/constants';
import {CHANNELS_CONTACTS} from 'presentation/pages/private/help/constants/channelsContacts';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useTheme} from 'styled-components';

const {SAC} = translations['pt-br'].privateFlow.help.channels.hap;

export function PhoneChannelsSection() {
	const theme = useTheme();
	const {isGndiSaoPaulo, isCCG, isGndiMinas, isClinipam, isHAP, isNotredameSaude} = useHostName();

	let operator: string | null = null;

	if (isGndiSaoPaulo) operator = ProductEnum.GNDI;
	else if (isHAP) operator = ProductEnum.HAP;
	else if (isGndiMinas) operator = ProductEnum.GNDI_MINAS;
	else if (isClinipam) operator = ProductEnum.CLINIPAM;
	else if (isCCG) operator = ProductEnum.CCG;
	else if (isNotredameSaude) operator = ProductEnum.NOTREDAME_SAUDE;

	const renderContent = () => {
		switch (operator) {
			case ProductEnum.GNDI:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<CopySection
							value={CHANNELS_CONTACTS.NDI_SAO_PAULO.SAC.phone1}
							mask={CopySectionMaskEnum.LONG_PHONE}
							callAction
							highlightedIcons
						/>
					</Stack>
				);

			case ProductEnum.HAP:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<Stack gap={1}>
							<Typography variant="body1" color={theme.palette.primary.main}>
								{SAC.region1}
							</Typography>
							<CopySection
								value={CHANNELS_CONTACTS.HAPVIDA.SAC.NO_NE.phone1}
								mask={CopySectionMaskEnum.LONG_PHONE}
								callAction
								highlightedIcons
							/>
						</Stack>
						<Stack gap={1}>
							<Typography variant="body1" color={theme.palette.primary.main}>
								{SAC.region2}
							</Typography>
							<CopySection
								value={CHANNELS_CONTACTS.HAPVIDA.SAC.S_SE_CO.phone1}
								mask={CopySectionMaskEnum.LONG_PHONE}
								callAction
								highlightedIcons
							/>
						</Stack>
					</Stack>
				);

			case ProductEnum.GNDI_MINAS:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<CopySection
							value={CHANNELS_CONTACTS.NDI_MINAS.SAC.phone1}
							mask={CopySectionMaskEnum.LONG_PHONE}
							callAction
							highlightedIcons
						/>
					</Stack>
				);

			case ProductEnum.CLINIPAM:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<CopySection
							value={CHANNELS_CONTACTS.CLINIPAM.SAC.phone1}
							mask={CopySectionMaskEnum.LONG_PHONE}
							callAction
							highlightedIcons
						/>
					</Stack>
				);

			case ProductEnum.CCG:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<CopySection
							value={CHANNELS_CONTACTS.CCG.SAC.phone1}
							mask={CopySectionMaskEnum.LONG_PHONE}
							callAction
							highlightedIcons
						/>
					</Stack>
				);

			case ProductEnum.NOTREDAME_SAUDE:
				return (
					<Stack gap={2}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<CopySection
							value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.SAC.phone1}
							mask={CopySectionMaskEnum.LONG_PHONE}
							callAction
							highlightedIcons
						/>
					</Stack>
				);

			default:
				return null;
		}
	};

	return <Stack>{renderContent()}</Stack>;
}
